import React, { createContext, useState, useContext, useEffect, useCallback } from "react";

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

const THEME_KEY = "dashboard-theme";

export const THEMES = {
  DARK: "dark",
  LIGHT: "light",
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const stored = localStorage.getItem(THEME_KEY);
    return stored === THEMES.LIGHT ? THEMES.LIGHT : THEMES.DARK;
  });

  // Set during render, not in the effect: charts read the theme tokens off <html> while they
  // render, which happens before our effect runs, so an effect left them one theme behind.
  document.documentElement.setAttribute("data-theme", theme);

  useEffect(() => {
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === THEMES.DARK ? THEMES.LIGHT : THEMES.DARK));
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
